export enum OrderStatusEnum {
  open = 'open',
  processing = 'processing',
  paid = 'paid',
  closed = 'closed',
  offerAccepted = 'offer accepted'
}
